module.exports = "/images/v3_logo.svg?2ffc45c13785c8297d4f9e6d3dd05bb4";